import storage from '../storage';

export const getLocalSettingsSounds = () => {
  const {
    error = true,
    success = true,
    info = true,
  } = storage.getItem('sounds') || {};

  return {
    error,
    success,
    info,
  };
};

export const getLocalSettingsPnlInTab = () => {
  const { algoList = true, algoConfig = true } =
    storage.getItem('pnlInBrowserTab') || {};

  return {
    algoList,
    algoConfig,
  };
};

const defaultUnderlyingPriceTickerSymbols = {
  'NIFTY 50': true,
  SENSEX: true,
  'NIFTY BANK': true,
};

export const getLocalSettingsUnderlyingPriceTicker = () => {
  let data = storage.getItem('underlyingPriceTicker');

  if (!data) {
    storage.setItems({
      underlyingPriceTicker: defaultUnderlyingPriceTickerSymbols,
    });

    data = storage.getItem('underlyingPriceTicker');

    return data;
  }

  const trueCount = Object.values(defaultUnderlyingPriceTickerSymbols).filter(
    (value) => value === true
  ).length;

  if (trueCount > 4) {
    storage.setItems({
      underlyingPriceTicker: defaultUnderlyingPriceTickerSymbols,
    });

    data = storage.getItem('underlyingPriceTicker');

    return data;
  }

  return data;
};

export const getLocalSettingsShowOrderIds = () => {
  const isShow = storage.getItem('showOrderIds') === false ? false : true;

  return isShow;
};
